// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1gd9G","alert":"SettungsInbox_alert__3aQhk"};